var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8774 5.51759V13.1988C22.8774 13.8616 22.3334 14.3987 21.6623 14.3987H18.0157H3.43035H1.48585C1.48585 15.0093 1.75087 15.5912 2.21302 15.9965L4.63798 18.125C5.41686 18.8079 5.86177 19.7876 5.86177 20.8162V21.6002C5.86177 22.9256 4.77372 24 3.43143 24C2.08914 24 1 22.9246 1 21.5991V14.3987V11.9989C1 10.6735 2.08805 9.59912 3.43035 9.59912H11.5164C12.5582 9.59912 13.5493 10.0385 14.242 10.8075L16.3976 13.202C16.808 13.6584 17.3973 13.92 18.0157 13.92V4.79957H3.43035C2.08805 4.79957 1 3.7252 1 2.39979C1 1.07437 2.08805 0 3.43035 0H11.5164C12.5582 0 13.5493 0.439323 14.242 1.2084L16.3976 3.60287C16.808 4.05921 17.3973 4.32089 18.0157 4.32089H21.6623C22.3334 4.31664 22.8774 4.85488 22.8774 5.51759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalm);
export default __webpack_public_path__ + "static/media/palm.be58f287814a838109efc776359a6826.svg";
export { ForwardRef as ReactComponent };